import { Box, styled, Typography } from "@mui/material";
import { FC } from "react";

import { divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";

/** 固定商品 pill shown next to the name of a default (generated) product. */
export const FixedProductBadge: FC = () => {
  return (
    <BadgeBox>
      <Typography variant="cap12" color={text.primary} whiteSpace="nowrap">
        固定商品
      </Typography>
    </BadgeBox>
  );
};

const BadgeBox = styled(Box)`
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  min-width: 76px;
  height: 26px;
  flex: none;
  background: #ffffff;
  border: 1px solid ${divider.high};
  border-radius: ${rounded.md};
  .MuiTypography-root {
    padding: 0;
    line-height: 150%;
    text-align: center;
  }
`;
